import advancedSearchTrackingService from "app/pages/sales-intelligence/sub-modules/advanced-search/services/tracking/advancedSearchTrackingService";
import type TechnologySignalFilters from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologySignalFilters";
import { buildTechnologiesTrackingValue } from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/signals-filters/helpers";
import trackingService from "app/pages/sales-intelligence/sub-modules/signals/services/tracking/trackingService";
import type {
    SignalTechnologiesFilterProps,
} from "../../components/filters/SignalTechnologiesFilter/SignalTechnologiesFilter";
import SignalTechnologiesFilter from "../../components/filters/SignalTechnologiesFilter/SignalTechnologiesFilter";

type Props = Omit<SignalTechnologiesFilterProps, "onNoResultsFound"> & {
    signalAlias: string;
};

const SignalTechnologiesFilterTracked = (props: Props) => {
    const handleTrackedChange = (updatedFilters: Partial<TechnologySignalFilters>) => {
        const trackingValue = buildTechnologiesTrackingValue(updatedFilters);

        trackingService.filters.trackTechnologyFilterChange(trackingValue, props.signalAlias);
        props.onValueChange(updatedFilters);
    };

    const handleNoResultsFoundTracked = (query: string) => {
        advancedSearchTrackingService.trackTechnologyNotFound(query, props.signalAlias);
    };

    return (
        <SignalTechnologiesFilter
            {...props}
            onValueChange={handleTrackedChange}
            onNoResultsFound={handleNoResultsFoundTracked}
        />
    );
};

export default SignalTechnologiesFilterTracked;
